import React, { useEffect, useRef } from 'react';
import { CSVLink } from 'react-csv';

interface ExportToCSVProps {
  data: any;
  fileName: string;
  onSetCsvData: (data: any) => void;
}

export const ExportToCSV = (props: ExportToCSVProps) => {
  const { data, fileName, onSetCsvData } = props;
  const csvInstance = useRef(null);
  useEffect(() => {
    if (data && csvInstance && csvInstance.current && (csvInstance.current as any).link) {
      setTimeout(() => {
        csvInstance.current && (csvInstance.current as any).link.click();
        onSetCsvData(undefined);
      });
    }
  }, [data, onSetCsvData]);

  if (!data) {
    return null;
  }

  return <CSVLink data={data} asyncOnClick filename={fileName} ref={csvInstance} data-interception="off" />;
};
